import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { usePackagingItemIssues } from '@/shared/hooks/api/packagingItemIssues'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { PackagingItemIssuesSectionList } from './PackagingItemIssuesSectionList'

export function PackagingItemIssuesPage() {
  const { t } = useTranslation('packagingSuppliers')
  const { data, isLoading, isError } = usePackagingItemIssues()

  return (
    <>
      <Header fixed>
        <Search />
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>
      <Main className='flex flex-1 flex-col gap-4 px-6 sm:gap-6'>
        <div className='shrink-0'>
          <h1 className='text-2xl font-bold tracking-tight'>
            {t('issuesDashboard.title')}
          </h1>
          <p className='text-muted-foreground'>
            {t('issuesDashboard.description')}
          </p>
        </div>

        {isLoading && (
          <p className='text-sm text-muted-foreground'>
            {t('issuesDashboard.loading')}
          </p>
        )}

        {isError && (
          <Alert variant='destructive'>
            <AlertTriangle className='size-4' />
            <AlertTitle>{t('issuesDashboard.errorTitle')}</AlertTitle>
            <AlertDescription>{t('issuesDashboard.errorDescription')}</AlertDescription>
          </Alert>
        )}

        {!isLoading && !isError && data != null && (
          <PackagingItemIssuesSectionList sections={data.sections} />
        )}
      </Main>
    </>
  )
}
